import {Col, Row} from "antd";
import React from "react";
import realTime from "../../../../assets/images/icon/Real-time Data Sync.svg";
import support from "../../../../assets/images/icon/Multilingual Support.svg";
import admin from "../../../../assets/images/icon/Powerful Admin Panel.svg";
import summary from "../../../../assets/images/icon/AI-based Summary.svg";
import Mobile from "../../../../assets/images/whyAppMobile.png";

const WhyThis: React.FC<any> = () => {
    return (
        <>
            <section className="section whyThisSection" id="kapturely">
                <div className="container">
                    <Row className="heading">
                        <h2>Why kapturely?</h2>
                        <p>
                            Capturing and organizing leads is a breeze with kapturely. Users can add
                            photos, business cards, and voice notes with ease and its robust offline
                            mode enables them to capture every lead even without an Internet. Users
                            can automate the process of sending personalized emails and WhatsApp
                            messages to leads after adding data. Here are the benefits that make
                            kapturely your preferred online lead organizer-
                        </p>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <div className="serviceCard">
                                <Row>
                                    <Col span={24}>
                                        <div className="card">
                                            <div className="cardImg">
                                                <img src={summary} alt="summary" />
                                            </div>
                                            <div className="cardContent">
                                                {/* <p>Lorem Ipsum</p> */}
                                                <h3>AI-powered Lead Summaries</h3>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="rightRow">
                                    <Col span={24}>
                                        <div className="card">
                                            <div className="cardImg">
                                                <img src={support} alt="support" />
                                            </div>
                                            <div className="cardContent">
                                                {/* <p>Lorem Ipsum</p> */}
                                                <h3>Multilingual Support</h3>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <div className="card">
                                            <div className="cardImg">
                                                <img src={realTime} alt="real time" />
                                            </div>
                                            <div className="cardContent">
                                                {/* <p>Lorem Ipsum</p> */}
                                                <h3>Real-time Data Sync</h3>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="rightRow">
                                    <Col span={24}>
                                        <div className="card">
                                            <div className="cardImg">
                                                <img src={admin} alt="admin" />
                                            </div>
                                            <div className="cardContent">
                                                {/* <p>Lorem Ipsum</p> */}
                                                <h3>Powerful Admin Panel</h3>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col span={12} className="appImg">
                            <img src={Mobile} alt="mobile app image" />
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default WhyThis;
